import { escapeHtml, externalLinkButton } from '../ui/dom.js';

export interface Book {
  Title?: string;
  Categories: string[];
  Authors: string[];
  Description?: string;
  URL?: string;
}

export interface BooksData {
  Recommendations?: Book[];
}

/** One wa-card per book; parent should use class card-grid (same as home featured pages). */
export function renderBooks(items: Book[]): string {
  return items
    .map((item) => {
      const link = item.URL ? ` ${externalLinkButton(item.URL)}` : '';
      const authorsLabel = item.Authors.length > 1 ? 'Authors' : 'Author';
      return `<wa-card class="book-card" appearance="outlined">
        <h4 slot="header">${escapeHtml(item.Title ?? '')}${link}</h4>
        <p><strong>Categories:</strong> ${escapeHtml(item.Categories.join(', '))}</p>
        <p><strong>${authorsLabel}:</strong> ${escapeHtml(item.Authors.join(', '))}</p>
        <p>${escapeHtml(item.Description ?? '')}</p>
      </wa-card>`;
    })
    .join('\n        ');
}
